import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { uiToken } from '~/shared/constants/uiToken';

const SLIDE_VALUE = '8px';

export const StyledForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const InputCardNumber = styled.fieldset`
  position: relative;
`;

export const classNameIsRevealedCardNumber = css`
  /* @stylelint-disable-next-line no-empty-source */
`;

export const MaskedCardNumber = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  transform: translateX(0);
  padding: 12px 12px 12px 52px;
  background-color: transparent;
  border: 1px solid transparent;
  border-bottom: none;
  font-variant-numeric: tabular-nums;
  opacity: 1;
  pointer-events: none;
  transition-duration: var(${uiToken.animation.durationFast});
  transition-property: opacity, transform;
  transition-timing-function: ease-in-out;
  background-color: ${uiToken.color.background.input}!important;
  border-radius: 12px;
  width: 100%;
  border: 1px solid ${uiToken.color.border.default}!important;

  .${classNameIsRevealedCardNumber} & {
    transform: translateX(${SLIDE_VALUE});
    opacity: 0;
  }
`;

export const classNameRootInputCardNumber = css`
  width: 100%;
`;

export const InputBlock = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  margin-top: 8px;
`;

export const classNameInputCardNumber = css`
  transform: translateX(-${SLIDE_VALUE});
  font-variant-numeric: tabular-nums;
  opacity: 0;
  transition-duration: var(${uiToken.animation.durationFast});
  transition-property: opacity, transform;
  transition-timing-function: ease-in-out;
  background-color: ${uiToken.color.background.input}!important;
  border: 1px solid ${uiToken.color.border.default}!important;

  .${classNameIsRevealedCardNumber} & {
    transform: translateX(0);
    opacity: 1;
  }
`;

export const classNameInputSlave = css`
  font-variant-numeric: tabular-nums;
  background-color: ${uiToken.color.background.input}!important;
  border: 1px solid ${uiToken.color.border.default}!important;
`;

export const singleInput = css`
  margin-top: 16px;
`;

export const classNameInputDisabled = css`
  &:disabled {
    cursor: default;
    user-select: none;
  }
`;

export const StyledSpinnerContainer = styled.div`
  display: flex;
  width: 32px;
  height: 24px;
  border-radius: 4px;
  align-items: center;
  justify-content: center;
`;
